import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { H4 } from 'foundations-components/transitional/components/H4';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { featureDisabledActionTypes } from '../../constants/features';
import { AppContext } from '../../contexts/app/context';
import { InfoIcon } from 'foundations-assets/icons/components/InfoIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function FeaturePopupOver({
  featureDisabledReason,
  portalId,
  openUrl,
  featureTipsLink,
  reconnectRoute
}) {
  const history = useHistory();
  const [popupOpen, setPopupOpen] = useState(false);
  const {
    appName
  } = useContext(AppContext);
  const onRedirectLinkClick = e => {
    e.preventDefault();
    e.stopPropagation();
    openUrl(featureTipsLink);
  };
  const renderContentProperty = () => {
    const header = /*#__PURE__*/_jsx(H4, {
      "data-test-id": `${appName}-feature-popover-header`,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationModals.popupOver.header"
      })
    });
    const body = /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: `associationModals.popupOver.${featureDisabledReason === featureDisabledActionTypes.redirect ? featureDisabledActionTypes.redirect : featureDisabledActionTypes.reconnect}.body1`,
        "data-test-id": `${appName}-feature-popover-body-1`
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `associationModals.popupOver.${featureDisabledReason === featureDisabledActionTypes.redirect ? featureDisabledActionTypes.redirect : featureDisabledActionTypes.reconnect}.body2`,
        "data-test-id": `${appName}-feature-popover-body-2`
      })]
    });
    const redirectFooter = /*#__PURE__*/_jsx(Link, {
      external: true,
      truncate: true,
      onClick: onRedirectLinkClick,
      href: featureTipsLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationModals.popupOver.redirect.footer",
        "data-test-id": `${appName}-feature-popover-redirect-footer`
      })
    });
    const reconnectFooter = /*#__PURE__*/_jsx(Button, {
      size: "small",
      use: "tertiary",
      onClick: () => history.push(`${reconnectRoute}?portalId=${portalId}&backward=true`),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "associationModals.popupOver.reconnect.footer",
        "data-test-id": `${appName}-feature-popover-reconnect-footer`
      })
    });
    const footer = featureDisabledReason === featureDisabledActionTypes.redirect ? redirectFooter : reconnectFooter;
    return {
      header,
      body,
      footer
    };
  };
  return /*#__PURE__*/_jsx(Popover, {
    open: popupOpen,
    showCloseButton: true,
    autoPlacement: true,
    onOpenChange: evt => setPopupOpen(evt.target.value),
    content: renderContentProperty(),
    children: /*#__PURE__*/_jsx(IconButton, {
      "data-test-id": `${appName}-feature-popover-button`,
      use: "transparent",
      onClick: () => setPopupOpen(!popupOpen),
      children: /*#__PURE__*/_jsx(InfoIcon, {})
    })
  });
}
export default FeaturePopupOver;